// @ts-nocheck (needed because of non-TS React component)

import Button from '@fec/frontend/elements/buttons/button/button';

type Props = {
  disabled: boolean;
  onClick: Function;
};

export const SubmitButton = ({ disabled, onClick }: Props) => {
  return (
    <Button
      buttonText={'Kommentieren'}
      styleModifier={disabled ? 'button--inactive' : ''}
      additionalAttributes={{ disabled: disabled }}
      onClick={onClick}
    />
  );
};
